import { useQuery, QueryFunction } from 'react-query';
import { getAllTrucksCompanies, GetTrucksCompaniesQueries, TruckCompany } from '../../services/apiSLTP/materials/trucksCompanies';

type UseTrucksCompaniesQueryOptions = { queries?: GetTrucksCompaniesQueries };

const getTrucksCompanies: QueryFunction<TruckCompany[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseTrucksCompaniesQueryOptions];
    const { queries } = options;

    const response = await getAllTrucksCompanies(queries);
    return response.data;
};

export const useTrucksCompaniesQuery = (options: UseTrucksCompaniesQueryOptions) => {
    return useQuery(['trucksCompanies', options], getTrucksCompanies);
};
